export * from './app-svg-icons.config';
export * from './assets-n-files.config';
